import ImageBox from '../components/image-box/image-box-component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';
import imageData from '../data/image-data';
//import tw from "twin.macro";

const PhotoPage = () => (
   <VideoBehindText mainText="Photographs" url="bg.jpg">
      <div className="flex flex-wrap justify-center">
         {
            imageData.map((image, index) => <ImageBox {...image} key={index} />)
         }
      </div>
   </VideoBehindText>
);

export default PhotoPage;